module.exports = __webpack_public_path__ + "img/virtual-id-250.394213cd.png";